/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect, useRef } from 'react';
export const Checkbox = ({ className, children, fluid, handleChange = () => { }, checked, }) => {
    const ref = useRef();
    useEffect(() => {
        var _a;
        (_a = ref.current) === null || _a === void 0 ? void 0 : _a.addEventListener("checkbox:change", handleChange);
        return () => {
            var _a;
            (_a = ref.current) === null || _a === void 0 ? void 0 : _a.removeEventListener("checkbox:change", handleChange);
        };
    }, []);
    return (React.createElement("puk-checkbox", { ref: ref, customclass: className, fluid: fluid, checked: checked }, children));
};
Checkbox.defaultProps = {
    fluid: false,
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    onChange() { },
    customClass: '',
};
